import { useEffect, useState } from "react";
import api from "@/lib/api";
import { EnvelopeSimple, CheckCircle, Circle, Lightning } from "@phosphor-icons/react";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" }) : null);
const EMAIL_LABEL = { sent: "Envoyé", delivered: "Délivré", opened: "Ouvert", clicked: "Cliqué", bounced: "Rejeté" };

export default function SequenceStatus({ c }) {
  const [seq, setSeq] = useState(null);
  const [heat, setHeat] = useState(null);
  useEffect(() => {
    api.get(`/companies/${c.id}/sequence`).then((r) => setSeq(r.data)).catch(() => setSeq({ in_sequence: false }));
    api.get(`/companies/${c.id}/heat`).then((r) => setHeat(r.data)).catch(() => {});
  }, [c.id]);
  if (!seq || !seq.in_sequence) return null;
  const heatStyle = { hot: { bg: "#fee2e2", fg: "#b91c1c", icon: "🔥" }, warm: { bg: "#fef3c7", fg: "#b45309", icon: "🌤" }, cold: { bg: "#f1f5f9", fg: "#64748b", icon: "❄️" } };

  return (
    <div className="border border-border bg-white" data-testid="sequence-status">
      <div className="px-4 py-3 border-b border-border flex items-center justify-between gap-2 flex-wrap">
        <span className="flex items-center gap-2 text-sm font-head font-bold text-primary">
          <EnvelopeSimple size={16} weight="fill" /> Séquence d'emails
        </span>
        <div className="flex items-center gap-1.5">
          {heat && (
            <span className="inline-flex items-center gap-1 text-[10px] font-semibold px-2 py-0.5 rounded-full" data-testid="heat-pill"
              style={{ background: heatStyle[heat.level].bg, color: heatStyle[heat.level].fg }} title={`Score de chaleur : ${heat.score}/100`}>
              {heatStyle[heat.level].icon} Cible {heat.label} · {heat.score}
            </span>
          )}
          {(seq.engaged || seq.has_rdv) && (
            <span className="inline-flex items-center gap-1 text-[10px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 px-2 py-0.5 rounded-full" data-testid="sequence-engaged">
              <Lightning size={11} weight="fill" /> Engagé
            </span>
          )}
        </div>
      </div>
      <div className="p-4">
        <div className="text-xs text-muted-foreground mb-3">État : <b className="text-foreground">{seq.current}</b></div>
        <div className="space-y-3">
          {seq.steps.map((s) => (
            <div key={s.key} className="flex items-center gap-3" data-testid={`seq-status-${s.key}`}>
              {s.done
                ? <CheckCircle size={18} weight="fill" className="text-emerald-600 shrink-0" />
                : <Circle size={18} className="text-muted-foreground/40 shrink-0" />}
              <div className="flex-1 flex items-center justify-between">
                <span className={`text-sm ${s.done ? "font-medium" : "text-muted-foreground"}`}>{s.label}</span>
                <span className="text-xs text-muted-foreground font-mono">
                  {s.done ? (fmt(s.date) || "fait") : "en attente"}
                  {s.key === "initial" && s.status && EMAIL_LABEL[s.status] && (
                    <span className="ml-2 text-emerald-700">· {EMAIL_LABEL[s.status]}</span>
                  )}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
